import React, { Component } from "react";
import * as Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { numberWithCommas, getStrokeColor, kmFormatter } from "../utils";
import HighchartsCustomEvents from "highcharts-custom-events";

HighchartsCustomEvents(Highcharts);
class ChannelAnalysisChart extends Component {
    state = {};
    chartComponent = React.createRef();
    // componentDidUpdate(prevProps) {
    //     if (this.props.resizedCount !== prevProps.resizedCount && this.props.data && !this.props.data.nodata) {
    //         this.chartComponent.current.chart.setSize(null, null);
    //         this.chartComponent.current.chart.reflow();
    //     }
    // }

    componentDidMount() {
        this.ro = new ResizeObserver(() => {
            setTimeout(() => {
                this.chartComponent.current.chart.setSize(null, null);
                this.chartComponent.current.chart.reflow();
            }, 0);
        });
        if (this.props.widgetContainerRef.current) {
            this.ro.observe(this.props.widgetContainerRef.current);
        }
    }

    componentWillUnmount() {
        this.ro.disconnect();
    }

    formatEngagementData(data) {
        let res = [];
        let total = Object.values(data)
            .map((x) => x.total)
            .reduce((x, y) => x + y, 0);
        for (let platform in data) {
            let platformName = this.props.allPlatforms.find((plt) => plt.id === platform);
            let short_name = platformName.short_name;
            platformName = platformName ? platformName.name : "";
            let Engagements = data[platform].total;
            let color = getStrokeColor(short_name);
            let percentage = ((data[platform].total / total) * 100).toFixed(2);
            res.push({
                y: Engagements,
                displayY: numberWithCommas(Engagements),
                color: color,
                name: platformName,
                platformId: platform,
                percent: percentage,
                totalVal: total,
            });
        }
        res = res && res.sort((a, b) => b.y - a.y);
        return res;
    }

    getOptions = () => {
        //  let total = this.props.data.total;
        let chartData = this.formatEngagementData(this.props.data);

        let self = this;

        let chartConfig = {
            chart: {
                type: "pie",
                className: "skiptranslate",
                backgroundColor: "transparent",
                spacingTop: 0,
                spacingBottom: 5,
                spacingLeft: 0,
                spacingRight: 0,
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
            },
            title: {
                text: ``,
            },
            credits: {
                enabled: false,
            },
            plotOptions: {
                pie: {
                    borderWidth: 0,
                    shadow: false,
                    showInLegend: true,
                    dataLabels: {
                        enabled: this.props.showLabel,
                        distance: "10%",
                        color: this.props.insights__recommendation ? "white" : undefined,
                        //format: "{point.name}: {point.displayY}",
                        formatter: function () {
                            return `<span>${this.point.name}: </span> <span>${this.point.percent}%</span>
                            `;
                        },
                        style: {
                            fontWeight: 400,
                            textOutline: "none",
                        },
                    },
                    point: {
                        events: {
                            contextmenu: function (e) {
                                e.preventDefault();
                                self.props.addContextMenuListener ? self.props.addContextMenuListener(e.x, e.y, this) : null;
                            },
                        },
                    },
                },
            },
            legend: {
                enabled: this.props.showLegendBar,
                itemStyle: {
                    fontWeight: 400,
                    color: this.props.insights__recommendation ? "white" : "#333333",
                },
                itemHoverStyle: {
                    color: this.props.insights__recommendation ? "#84acd1" : "#000000",
                },
                alignColumns: false,
                margin: 0,
                align: "center",
            },
            lang: {
                noData: "No data.",
            },
            noData: {
                style: {
                    fontWeight: "bold",
                    fontSize: "15px",
                    color: "#303030",
                },
                position: {
                    align: "center",
                },
            },
            series: [
                {
                    data: chartData,
                },
            ],
            tooltip: {
                //valueSuffix: "%",
                followPointer: true,
                followTouchMove: true,
                backgroundColor: "#fff",
                borderRadius: 6,
                formatter: function () {
                    return `<span>${this.point.name}</span> <br/> <span>Impact Score |  <b>${this.point.percent}% | </b>
                   <span> <b>${numberWithCommas(this.point.y)}</b> / <b>${numberWithCommas(this.point.totalVal)}</b></span>
                    </span>`;
                },
            },
        };
        return chartConfig;
    };

    render() {
        return (
            <HighchartsReact
                highcharts={Highcharts}
                options={this.getOptions()}
                ref={this.chartComponent}
                containerProps={{ style: { width: "100%", height: "100%" } }}
            />
        );
    }
}

export default ChannelAnalysisChart;
